import React from 'react';
import FooterCopy from './FooterCopy';
import FooterMenu from './FooterMenu';

const Footer = () => {
  return (
    <footer>
      <FooterMenu />
      <FooterCopy />
    </footer>
  );
};

export default Footer;
